"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePermissionError = exports.FileWriteError = void 0;
exports.saveDoc = saveDoc;
const fs = __importStar(require("fs-extra"));
const path = __importStar(require("path"));
const dist_1 = require("../../../core/dist");
class FileWriteError extends Error {
    constructor(filePath, originalError) {
        super(`Failed to write ${filePath}: ${originalError.message}`);
        this.filePath = filePath;
        this.name = 'FileWriteError';
    }
}
exports.FileWriteError = FileWriteError;
class FilePermissionError extends Error {
    constructor(filePath) {
        super(`Permission denied writing to ${filePath}`);
        this.filePath = filePath;
        this.name = 'FilePermissionError';
    }
}
exports.FilePermissionError = FilePermissionError;
async function saveDoc(doc, filePath) {
    // Separate internal/transient properties from frontmatter. `_stepsFromFrontmatter`
    // is a load-time provenance marker (see frontmatterLoader) — never serialized.
    const { content, _path, _stepsFromFrontmatter, steps, ...rest } = doc;
    // A plan is "frontmatter-native" when its steps came from (or were authored as) a
    // structured frontmatter block. Only those re-persist the steps block — a legacy
    // plan keeps its body table as the store until the explicit migration command
    // converts it, so saving (e.g. complete_step) never implicitly migrates.
    const frontmatterNative = doc.type === 'plan' && _stepsFromFrontmatter === true && Array.isArray(steps);
    // Body: the steps table is a generated view. Regenerate it from steps in place,
    // preserving the authored Goal / `### Step N` detail / Notes prose around it. Then
    // re-key the per-step detail sections by stable id (Option A) so they survive
    // reorder/add/remove — authored prose preserved, orphans pruned, `Step N` renumbered.
    let bodyContent = content;
    if (doc.type === 'plan' && steps) {
        bodyContent = (0, dist_1.updateStepsTableInContent)(content, steps);
        bodyContent = (0, dist_1.rekeyDetailSections)(bodyContent, steps);
    }
    if (rest.title) {
        bodyContent = (0, dist_1.syncBodyH1)(bodyContent ?? '', rest.title);
    }
    // Serialize frontmatter; include the structured steps block only for native plans.
    const frontmatter = frontmatterNative ? { ...rest, steps } : rest;
    const frontmatterStr = (0, dist_1.serializeFrontmatter)(frontmatter);
    const output = `${frontmatterStr}\n${bodyContent}`;
    await fs.ensureDir(path.dirname(filePath));
    const tempPath = path.join(path.dirname(filePath), `.loom-tmp-${Date.now()}-${path.basename(filePath)}.tmp`);
    try {
        await fs.writeFile(tempPath, output, { mode: 0o644 });
        try {
            await fs.rename(tempPath, filePath);
        }
        catch (renameErr) {
            if (renameErr.code === 'EXDEV') {
                await fs.copyFile(tempPath, filePath);
                await fs.remove(tempPath);
            }
            else {
                throw renameErr;
            }
        }
    }
    catch (e) {
        await fs.remove(tempPath).catch(() => { });
        if (e.code === 'EACCES' || e.code === 'EPERM') {
            throw new FilePermissionError(filePath);
        }
        if (e.code === 'ENOSPC') {
            throw new FileWriteError(filePath, new Error('Disk full'));
        }
        throw new FileWriteError(filePath, e);
    }
}
